// src/router/PublicRoute.js
import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getAuthenticated } from "utils/functions";

const PublicRoute = ({ component: Component, ...rest }) => {
  const isAuthenticated = getAuthenticated();

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? <Redirect to="/" /> : <Component {...props} />
      }
    />
  );
};

export default PublicRoute;
